module.exports = __webpack_public_path__ + "img/satellite.db703ffc.png";